<template>
	<v-dialog class="edit_marketing_group" v-model="setdialog.dialog" max-width="800" persistent>
		<v-layout class="create_wrap marketer_dialog_layout  display_inline_block " xs12>
			<!-- 헤더 -->
			<div class="project_title px-5" :style="`background-color:${$store.state.PointColor2}`">
				<!-- text -->
				<h2 style="font-size:15px">마케터 그룹 관리</h2>
				<v-spacer />
				<!-- icon -->
				<v-icon @click="clickConfirm()" class="title-icon" color="white">mdi-close</v-icon>
			</div>
			<!-- 헤더 끝-->
			<v-layout column style=" background-color: #eee; padding: 20px;" wrap>
				<v-layout wrap column style="border: 1px solid #d9d9d9; background-color: #fff">
					<v-layout class="mx-8 mt-5" wrap>
						<v-flex xs12 my-2>
							<v-layout align-center>
								<div class="slash mr-1"></div>
								<span class="title_font"> 마케터 그룹 설정 </span>
							</v-layout>
						</v-flex>
						<!-- 컨테이너 -->

						<v-layout>
							<!-- 컨테이너 ---1 -->
							<v-flex xs4 column class="pr-1 emg-container-box">
								<div style="border: 1px solid #c8c8c8;">
									<v-layout class="group-header-container" row align-center height="15%">
										<v-flex pa-2>
											총괄
										</v-flex>
									</v-layout>
									<!-- 내용 중간 컨테이너 -->
									<v-layout class="group-content-container" px-0 py-0 height="70%">
										<!-- 삭제 버튼과 입력란 컨테이너 시작-->

										<v-layout xs12 py-2 v-for="(item, index) in glSel.items" :key="index">
											<v-flex xs8>
												<txtField class="search_box" v-model="item.text" :txtField="show_field"></txtField>
											</v-flex>
											<v-flex xs3>
												<btn
													:btn="deleteBtn"
													:class="'small_action_btn'"
													:btn_txt="'삭제'"
													@click="updateDataNull('gl', item.value.id)"
												></btn>
											</v-flex>
										</v-layout>
										<!-- 삭제 버튼과 입력란 컨테이너 끝-->
									</v-layout>
									<!-- 추가 입력란 컨테이너 시작 -->
									<v-layout pr-4 py-3 row height="15%" style="border-top: 1px solid #c8c8c8;" justify-center>
										<v-flex xs9>
											<txtField class="search_box" v-model="glInput" :txtField="gl_add"></txtField>
										</v-flex>
										<v-flex xs3>
											<btn
												:btn="addBtn"
												:class="'small_action_btn'"
												:style="`background-color:${$store.state.PointColor2}`"
												:btn_txt="'추가'"
												@click="addData('gl')"
											></btn>
										</v-flex>
									</v-layout>
									<!-- 추가 입력란 컨테이너 끝 -->
								</div>
							</v-flex>
							<!-- 컨테이너 ---1 끝 -->
							<!-- 컨테이너 ---2 시작-->
							<v-flex xs4 column class="px-1 emg-container-box">
								<div style="border: 1px solid #c8c8c8;">
									<v-layout class="group-header-container" row align-center height="15%">
										<v-flex pa-2 xs3>
											본부
										</v-flex>
										<v-flex xs9 pr-3>
											<selectBox :sel="glSel" @change="changeGlSelect($event)" class="marketer_search_select"></selectBox>
										</v-flex>
									</v-layout>
									<!-- 내용 중간 컨테이너 -->
									<v-layout class="group-content-container" px-0 py-0 height="70%">
										<!-- 삭제 버튼과 입력란 컨테이너 시작-->

										<v-layout xs12 py-2 v-for="(item, index) in hqSel.items" :key="index">
											<v-flex xs8>
												<txtField class="search_box" v-model="item.text" :txtField="show_field"></txtField>
											</v-flex>
											<v-flex xs3>
												<btn
													:btn="deleteBtn"
													:class="'small_action_btn'"
													:btn_txt="'삭제'"
													@click="updateDataNull('hq', item.value.id)"
												></btn>
											</v-flex>
										</v-layout>
										<!-- 삭제 버튼과 입력란 컨테이너 끝-->
									</v-layout>
									<!-- 추가 입력란 컨테이너 시작 -->
									<v-layout pr-4 py-3 row height="15%" style="border-top: 1px solid #c8c8c8; ">
										<v-flex xs9>
											<txtField class="search_box" v-model="hqInput" :txtField="hq_add"></txtField>
										</v-flex>
										<v-flex xs3>
											<btn
												:btn="addBtn"
												:class="'small_action_btn'"
												:style="`background-color:${$store.state.PointColor2}`"
												:btn_txt="'추가'"
												@click="addData('hq')"
											></btn>
										</v-flex>
									</v-layout>
									<!-- 추가 입력란 컨테이너 끝 -->
								</div>
							</v-flex>

							<!-- 컨테이너 2 끝 --- -->
							<!-- 컨테이너 3 시작 --- -->
							<v-flex xs4 column class="pl-1 emg-container-box">
								<div style="border: 1px solid #c8c8c8;">
									<v-layout class="group-header-container" row align-center height="15%">
										<v-flex pa-2 xs3>
											팀
										</v-flex>
										<v-flex xs9 pr-3>
											<selectBox :sel="hqSel" @change="changeHqSelect($event)" class="marketer_search_select"></selectBox>
										</v-flex>
									</v-layout>
									<!-- 내용 중간 컨테이너 -->
									<v-layout class="group-content-container" px-0 py-0 column row height="70%">
										<!-- 삭제 버튼과 입력란 컨테이너 시작-->

										<v-layout xs12 py-2 v-for="(item, index) in teamArr" :key="index">
											<v-flex xs8>
												<txtField class="search_box" v-model="item.text" :txtField="show_field"></txtField>
											</v-flex>
											<v-flex xs3>
												<btn
													:btn="deleteBtn"
													:class="'small_action_btn'"
													:btn_txt="'삭제'"
													@click="updateDataNull('team', item.value.id)"
												></btn>
											</v-flex>
											<!-- 팀 삭제 따로 처리 -->
											<sweetAlert :dialog="sweetInfo" @click="deleteTeam('team', teamDelId)" />
										</v-layout>
										<!-- 삭제 버튼과 입력란 컨테이너 끝 -->
									</v-layout>
									<!-- 추가 입력란 컨테이너 시작 -->
									<v-layout pr-4 py-3 row height="15%" style="border-top: 1px solid #c8c8c8; ">
										<v-flex xs9>
											<txtField class="search_box" v-model="teamInput" :txtField="team_add"></txtField>
										</v-flex>
										<v-flex xs3>
											<btn
												:btn="addBtn"
												:class="'small_action_btn'"
												:style="`background-color:${$store.state.PointColor2}`"
												:btn_txt="'추가'"
												@click="addData('team')"
											></btn>
										</v-flex>
									</v-layout>
									<!-- 추가 입력란 컨테이너 끝 -->
								</div>
							</v-flex>
							<!-- 컨테이너 3끝 --- -->
						</v-layout>
					</v-layout>

					<v-layout class="mt-4 mb-7 mx-8">
						<v-flex sm12 style="text-align:end;">
							<btn
								:btn="cofirmBtn"
								:class="'small_action_btn'"
								:style="`background-color:${$store.state.PointColor2}`"
								:btn_txt="'확인'"
								@click="clickConfirm()"
							></btn>
						</v-flex>
					</v-layout>
					<sweetAlert :dialog="sweetDialog" />
				</v-layout>
			</v-layout>
		</v-layout>
	</v-dialog>
</template>

<script>
import { btn, txtField, selectBox, sweetAlert } from '@/components/index.js'
export default {
	components: { btn, txtField, selectBox, sweetAlert },
	props: {
		setdialog: Object,
		validation_chceck: Function,
		add_project: Function,
		delete_project: Function,
		businessId: String,
	},

	methods: {
		async clickConfirm() {
			this.setdialog.dialog = false
			if (this.groupChanged) {
				await this.$parent.marketerGroupChange()
			}
			this.groupChanged = false
		},
		// Team은 따로 빼서 삭제 진행 (확인/취소 필요하므로)
		async deleteTeam(type, id) {
			this.$store.state.loading = true
			await this.$store.dispatch('delTmUser', { teamId: id }).then(res => {
				const { status } = res.data.delTmUser.response

				if (status == 1001) {
					this.sweetDialog.open = true
					this.sweetDialog.title = '오류 발생'
					this.sweetDialog.content = `팀내 상담사에게 배분된 고객을 모두 회수 후 진행해주세요!`
				} else if (status == 1002) {
					this.sweetDialog.open = true
					this.sweetDialog.title = '오류 발생'
					this.sweetDialog.content = `제거하려는 팀이 존재하지 않습니다!`
				} else if (status == 1000) {
					this.groupChanged = true
				}
				return res.data
			})
			this.$store.state.loading = false

			this.getList(type)
			this.sweetInfo.open = false
			this.teamDelId = null
		},

		changeGlSelect(event) {
			this.getList('hq')

			this.hqSel.value = ''
			this.hqSel.items = []
			this.teamArr = []
			return event
		},
		changeHqSelect(event) {
			this.getList('team')
			return event
		},

		/**리스트 가져오기- 타입별 
		@param {String} type gl,hq,team
		@author 임호진
		*/
		async getList(type) {
			const businessId = this.businessId
			let query = ''
			let data = {}

			// 1. 타입별 쿼리와 파라미터 값을 정한다.
			if (type === 'gl') {
				query = 'generals'
				data = {
					businessId: String(businessId),
				}
			} else if (type === 'hq') {
				query = 'headquarters'
				data = {
					businessId: String(businessId),
					glId: String(this.glSel.value.id),
				}
			} else if (type === 'team') {
				query = 'teams'
				data = {
					businessId: String(businessId),
					glId: String(this.glSel.value.id),
					hqId: String(this.hqSel.value.id),
				}
			} else {
				query = ''
				return
			}

			// 2. 정해진 값으로 데이터를 불러온다.
			this.$store.state.loading = true
			await this.$store.dispatch(query, data).then(res => {
				const data = res.data[query]

				if (Array.isArray(data) && data.length > 0) {
					let new_arr = []

					for (let i = 0; i < data.length; i++) {
						let form = {
							text: data[i].title,
							value: data[i],
						}
						new_arr.push(form)
					}
					if (type == 'gl') {
						this.glSel.items = new_arr
					} else if (type == 'hq') {
						this.hqSel.items = new_arr
					} else if (type == 'team') {
						this.teamArr = new_arr
					}
				} else {
					if (type == 'gl') {
						this.glSel.items = []
					} else if (type == 'hq') {
						this.hqSel.items = []
					} else if (type == 'team') {
						this.teamArr = []
					}
				}
			})

			this.$store.state.loading = false
		},
		/**카테고리가 선택 유무에 따른 유효 검사 
		@param {String} type gl, hq, team
		@author 임호진
		@returns 타입이 맞고 선택됐으면 true 아니면 false 
		*/
		selectVali(type) {
			// validation

			if (!this.glSel.value && type == 'hq') {
				this.sweetDialog.open = true
				this.sweetDialog.title = '오류 발생'
				this.sweetDialog.content = `총괄이 선택되지 않았습니다!.`
				this.hqInput = ''

				return false
			} else if (!this.hqSel.value && type == 'team') {
				this.sweetDialog.open = true
				this.sweetDialog.title = '오류 발생'
				this.sweetDialog.content = `본부가 선택되지 않았습니다!.`
				this.teamInput = ''

				return false
			}
			return true
		},
		/**각 카테고리별 중복값 유무 유효성 검사
		@param {String} input 각 입력란의 문자열
		@param {String} type gl, hq, team
		@author 임호진
		@returns 중복이 아니면 true, 중복이면 false 반환
		*/
		duplicateVali(input, type) {
			let cateArr = []
			if (type == 'gl') {
				cateArr = this.glSel
			} else if (type == 'hq') {
				cateArr = this.hqSel
			} else if (type == 'team') {
				cateArr = this.teamArr
			}

			let myArr = type == 'team' ? cateArr.map(value => value.text) : cateArr.items.map(value => value.text)
			if (myArr.indexOf(input) >= 0) {
				this.sweetDialog.open = true
				this.sweetDialog.title = '오류 발생'
				this.sweetDialog.content = `중복값이 있어요!.`
				this.glInput = ''
				this.hqInput = ''
				this.teamInput = ''
				return false
			} else return true
		},

		/**데이터 생성- 타입별
		@param {String} type gl,hq,team
		@author 임호진
		*/
		async addData(type) {
			if (!this.selectVali(type)) return

			const inputs = {
				gl: this.glInput,
				hq: this.hqInput,
				team: this.teamInput,
			}
			const queries = {
				gl: 'createGeneral',
				hq: 'createHeadquarter',
				team: 'createTeam',
			}

			let input = inputs[type] || null

			if (this.duplicateVali(input, type) == false) return

			let query = queries[type] || null
			const datas = {
				gl: { title: input, businessId: this.businessId },
				hq: { title: input, businessId: this.businessId, glId: this.glSel.value.id },
				team: { title: input, businessId: this.businessId, glId: this.glSel.value.id, hqId: this.hqSel.value.id },
			}

			let data = datas[type] || null
			if (!input) {
				this.sweetDialog.open = true
				this.sweetDialog.title = '오류 발생'
				this.sweetDialog.content = `빈 값입니다.`
				this.sweetDialog.modalIcon = 'error'
				return
			}

			this.$store.state.loading = true
			await this.$store.dispatch(query, data).then(res => {
				return res.data
			})
			this.$store.state.loading = false
			this.glInput = ''
			this.hqInput = ''
			this.teamInput = ''
			this.groupChanged = true
			this.getList(type)
		},
		/**하위 요소에 값이 있는지 유무 확인
		@param {String} type gl,hq,team
		@param {String} id 고유 id
		@author 임호진
		*/
		async getLeftNum(type, id) {
			// team은 하위 요소가 없기에 0 반환
			if (type == 'team') return 0

			const queries = {
				gl: 'headquarters',
				hq: 'teams',
			}
			const params = {
				gl: { businessId: this.businessId, glId: id },
				hq: { businessId: this.businessId, hqId: id },
			}

			let query = queries[type] || null
			let param = params[type] || null

			this.$store.state.loading = true

			try {
				const res = await this.$store.dispatch(query, param)

				if (type === 'gl') {
					return Number(res.data.headquartersConnection.aggregate.count)
				} else {
					return Number(res.data.teamsConnection.aggregate.count)
				}
			} catch (error) {
				console.error('Error fetching data:', error)
				return 0
			} finally {
				this.$store.state.loading = false
			}
		},

		/**데이터 null 초기화- 타입별 
		@param {String} type gl,hq,team
		@param {String} id 고유 id
		@author 임호진
		*/
		async updateDataNull(type, id) {
			this.teamDelId = id

			if (type == 'team') {
				this.sweetInfo.open = true
				this.sweetInfo.title = '삭제'
				this.sweetInfo.content = `정말 삭제하시겠습니까?`
				this.sweetInfo.modalIcon = 'info'
				this.sweetInfo.buttonType = 'twoBtn'

				return
			}

			const num = await this.getLeftNum(type, id)
			if (num > 0) {
				this.sweetDialog.open = true
				this.sweetDialog.title = '오류 발생'

				this.sweetDialog.content = `${num}개의 ${type == 'gl' ? '본부' : '팀'} 데이터를 삭제 바랍니다`
				this.sweetDialog.modalIcon = 'error'
				return
			}

			const queries = {
				gl: 'updateGeneral',
				hq: 'updateHeadquarter',
			}
			let query = queries[type] || null

			this.$store.state.loading = true
			await this.$store.dispatch(query, { id: id }).then(res => {
				return res.data
			})
			if (type == 'gl' && this.glSel.value.id == id) {
				this.glSel.value = ''
			} else if (type == 'hq' && this.hqSel.value.id == id) {
				this.hqSel.value = ''
			}
			this.groupChanged = true
			this.$store.state.loading = false
			this.getList(type)
		},
	},
	watch: {
		setdialog: {
			deep: true,
			handler() {
				// 총괄만 가져오기 모달창 t/f에 따른
				if (this.setdialog.dialog) {
					this.getList('gl')
				}

				// 초기화
				this.glSel.value = ''
				this.hqSel.items = []
				this.teamArr = []
			},
		},
		'setdialog.dialog': {
			deep: true,
			handler() {
				if (this.setdialog.dialog === false) {
					this.glInput = ''
					this.hqInput = ''
					this.teamInput = ''
				}
			},
		},
	},
	data() {
		return {
			leftTeam: null,
			sweetDialog: {
				open: false,
				title: '',
				content: ``,
				modalIcon: 'info',
				cancelBtnText: '확인',

				buttonType: 'oneBtn',
			},
			sweetInfo: {
				//  밸리데이션
				open: false,
				title: '',
				content: ``,
				modalIcon: 'info',
				cancelBtnText: '취소',
				saveBtnText: '삭제',
				buttonType: 'oneBtn',
			},
			teamArr: [],
			glInput: '',
			hqInput: '',
			teamInput: '',
			gl_add: {
				placeholder: '총괄명 입력',
				maxlength: '255',
				outlined: true,
				backCol: 'white',
			},
			hq_add: {
				placeholder: '본부명 입력',
				maxlength: '255',
				outlined: true,
				backCol: 'white',
			},
			team_add: {
				placeholder: '팀명 입력',
				maxlength: '255',
				outlined: true,
				backCol: 'white',
			},
			addBtn: {
				color: '',
				dark: true,
			},
			deleteBtn: {
				color: '#8b8b8b',
				dark: true,
			},
			cofirmBtn: {
				color: '',
				dark: true,
				width: 94,
				height: 30,
			},
			glSel: {
				value: '',
				placeholder: '총괄 선택',
				errorMessage: '',
				hideDetail: true,
				items: [],
				itemText: 'text',
				outlined: true,
			},
			hqSel: {
				value: '',
				placeholder: '본부 선택',
				errorMessage: '',
				hideDetail: true,
				items: [],
				outlined: true,
			},

			show_field: {
				value: '',
				maxlength: '255',
				outlined: true,
				backCol: 'white',
				disabled: true,
				readonly: true,
			},
			clickedTeamId: null,

			groupChanged: false, // 그룹 추가 여부
			teamDelId: null, // 삭제할 팀 아이디
		}
	},
}
</script>

<style lang="scss">
.create_wrap {
	background: #fff;
}
.project_title {
	background: #323153;
	color: #fff;
	/* height: 60px; */
	display: flex;
	align-items: center;
}
.title_font {
	font-size: 15px;
	font-weight: bold;
}
.sub_text {
	border-left: 1px solid #d1d1d1;
}
.upload_box {
	margin: 0 auto !important;
}
.v-text-field__slot input {
	font-size: 12px;
	font-weight: normal;
}
.radioTime {
	.v-label {
		font-size: 0.75rem !important;
	}
}
.search_box {
	width: auto !important;
	height: 26px !important;
	margin-right: 8px !important;
	/* padding: 0 0 0 10px !important; */
	font-size: 13px;
	font-weight: bold;
	.v-btn__content {
		color: #fff;
	}
}
.marketer_search_select {
	min-height: 26px !important;
	/* max-width: none !important; */
	.v-input__control {
		.v-input__slot {
			min-height: 26px !important;
			height: 26px !important;
			font-size: 90%;
			padding: 0 10px !important;
		}
	}
	width: 100%;
	.v-input__append-inner {
		margin-top: 1px !important;
	}
}
.group-content-container {
	min-height: 185px;
	max-height: 185px;
	display: block !important;
	overflow-y: auto !important;
	overflow-x: hidden !important;
}
.group-header-container {
	background-color: #f2f4f6;
	border-bottom: 1px solid #d9d9d9;
}
.emg-container-box {
	overflow: hidden;
	min-width: 220px;
}
</style>
